import { useEffect, useState } from 'react'
import {
  Space,
  Button,
  Select,
  Popover,
  Input,
  Checkbox,
  Form,
  Menu,
  Dropdown,
  message,
  Avatar,
  Modal,
} from 'antd';
import axios from 'axios';
import { GlobalRegistry } from '@designable/core';
import { observer } from '@formily/react';
import { loadInitialSchema, saveSchema } from '../service';
import { useDesigner, TextWidget } from '../../designable/react';
import {  Link } from 'react-router-dom';
import {
  IFormilySchema,
  transformToSchema,
  transformToTreeNode,
} from '../../designable/formily-antd/transformer';
import { axiosInstance } from '../../store/store';
import { useNavigate } from 'react-router';

const supportLocales = ['zh-cn', 'en-us', 'ko-kr'];

interface FormData {
  id?: any
  formKey: any
  isCommit?:boolean
  branch?:string
  maindirectory?:string
  subdirectory?:string
  message?:string
}

type ParentProps = {
  // Define the type for the update function prop
  updateFormData: (value: FormData) => void
}

const GetMyAccountMenu = () => {
  let navigate = useNavigate()

  const [avatar, setAvatar] = useState(null)
  const [gitToken, setGitToken] = useState(null)
  const [gitApiUrl, setGitApiUrl] = useState(null)
  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()
  const menu = (
    <Menu>
      <Menu.Item>
        <a
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            setGitToken(
              gitToken ? gitToken : (localStorage?.getItem('token') as any)
            )
            setGitApiUrl(
              gitApiUrl ? gitApiUrl : (localStorage?.getItem('apiurl') as any)
            )
            setVisible(true)

          }}
        >
          System Preferences
        </a>
      </Menu.Item>
      <Menu.Item>
  
          <Link to="/logout">
          Logout
          </Link>
      </Menu.Item>
    </Menu>
  )




  const getProfile = async () => {
    let url = '/api/v1/control-center-new/staff/view-profile'
    let responseA = await axiosInstance.get(`${process.env.REACT_APP_API_URL}${url}`)

    if (responseA.status == 200) {
      if (responseA.data.profilePhotoPath) {
        console.log(129, responseA.data.profilePhotoPath)
        setAvatar(responseA.data.profilePhotoPath)
      }
      /*  let obj = {
          firstName: data?.firstName,
          lastName: data?.lastName,
          email: "",
          username: data?.user?.username*/
      //  }
      //  fetchImage(data?.profilePhotoPath)
      // setUserd(obj)
    } else {
      message.error('Something went wrong')
    }
  }

  const save = async () => {
    try {
      form
        .validateFields()
        .then(async (values) => {
          setLoading(false)

          form.resetFields()
          localStorage.setItem('token', values.token)
          localStorage.setItem('apiurl', values.apiurl)

          setVisible(false)

          form.setFieldsValue({ token: values.token })
          form.setFieldsValue({ apiurl: values.apiurl })
          let responseA = await axiosInstance.put(
            `${process.env.REACT_APP_API_URL}/api/v1/control-center-new/staff/update`,
            values
          )

          if (responseA.status == 200) {
            message.success('Schema updated Successfully')
          } else {
            message.error('Something went wrong')
          }
        })
        .catch((info) => {
          console.log('Validate Failed:', info)
          //setVisible(false)
        })
    } catch (error) { }
  }

  const handleOk = () => {
    setLoading(true)
    save()
  }

  const handleCancel = () => {
    setVisible(false)
  }

  useEffect(() => {
    getProfile()
  }, [])

  return (
    <>
      <Dropdown overlay={menu}>
        <Avatar src={avatar} />
      </Dropdown>
      <Modal
        title="System Preferences..."
        visible={visible}
        onCancel={handleCancel}
        onOk={handleOk}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleOk}
          >
            Save
          </Button>,
        ]}
      >
        <Form
          form={form}
          onFinish={save}
          initialValues={{ token: gitToken, apiurl: gitApiUrl }}
          layout="vertical"
          autoComplete="off"
        >
          <Form.Item
            name="apiurl"
            label="Git Repo API URL"
            rules={[{ required: true, message: 'Please input api url.' }]}
          >
            <Input placeholder="https://gitlab.example.com/api/v4/projects/:project_id" />
          </Form.Item>
          <Form.Item
            name="token"
            label="Git Repo Access Token"
            rules={[{ required: true, message: 'Please input access token.' }]}
          >
            <Input placeholder="" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

const PutUpdateSchemaPopOver = (propData: FormData) => {
  let [processKey, setProcessKey] = useState<FormData>(propData);
  let gitTokenX:any = null;
  let gitApiUrlX:any = null;
  const [visible, setVisible] = useState(false);
  const [commitOn, setCommitOn] = useState(true);
  const [form] = Form.useForm();
  const [gitBranches, setGitBranches] = useState([]);
  const [mainDirectories, setMainDirectories] = useState([]);
  const [subDirectories, setSubDirectories] = useState([]);
  const designer = useDesigner();
  const [gitToken, setGitToken] = useState(null);
  const [gitApiUrl, setGitApiUrl] = useState(null);
  const { TextArea } = Input;
  const { Option } = Select;
  const [loading, setLoading] = useState(false);
  const [action,setAction]= useState('create');

  useEffect(() => {
    setProcessKey(propData)
    setGitParams();
    form.resetFields();
    form.setFieldsValue(propData);
    console.log('ppp', propData)
   
  }, [propData,form])

  useEffect(() => {

    form.setFieldsValue(propData);

   
  }, [visible])

  const handleOk = () => {
    setLoading(true)
    save();
  }

  const handleCancel = () => {
    setVisible(false)
  }

  const onChange = (e: any) => {
    setCommitOn(e.target.checked)
  }

  const getGitBranches = async () => {
    setGitParams();

    if (!gitTokenX || !gitApiUrlX) return false;

    const responseA: any = await axios.get(`${gitApiUrlX}/repository/branches?private_token=${gitTokenX}`);
    if (responseA.status == 200) {
      setMainDirectories([]);
      setSubDirectories([]);
      setGitBranches(responseA.data);

    } else {
      message.error('Something went wrong');
    }
  }

  const getDirectories = async (path: any, callback: any, branch: any) => {
    setGitParams();


    let endurl = null;
    if (!gitTokenX || !gitApiUrlX) return false;

    if (path)
      endurl = `${gitApiUrlX}/repository/tree?private_token=${gitTokenX}&ref=${branch}&path=${path}`;
    else
      endurl = `${gitApiUrlX}/repository/tree?private_token=${gitTokenX}&ref=${branch}`;

    const responseA: any = await axios.get(`${endurl}`);
    if (responseA.status == 200) {
      callback(responseA.data);
    } else {
      message.error('Something went wrong');
    }
  }

  const setGitParams = () =>{
    gitTokenX = (localStorage?.getItem('token') as any);
    gitApiUrlX = (localStorage?.getItem('apiurl') as any);

  }

  const saveCommit = async (obj: any) => {
    setGitParams();


    try {
    const responseA: any = await axios.post(`${gitApiUrlX}/repository/commits?private_token=${gitTokenX}`, obj);
    setLoading(false);

    if (responseA.status == 201) {
      message.success('Schema updated Successfully');
      setVisible(false);
    }else if  (responseA.status == 400) {

      obj.actions[0].action="update";
      saveCommit(obj);
      
    }else {
      message.error('Something went wrong');
    }
  }catch (error:any) {
    // Handle other errors (e.g., network issues)
    if (error?.response?.status==400)
    {  
      obj.actions[0].action="update";
      saveCommit(obj);
    }
  }

  }

  const save = async () => {

    let responseA:any=null;
    let url:any = null;
    try {

      form
        .validateFields()
        .then(async (values) => {
          let desVar: IFormilySchema = { schema: {}, form: {} }
          // console.log('des', transformToSchema(designer.getCurrentTree()))
          desVar = transformToSchema(designer.getCurrentTree())

          if (!processKey?.formKey) {
            setLoading(false);
            return false;
          }


          let obj = { id:processKey.id,formKey:processKey.formKey, schema: desVar.schema }

          
          
         
          if (action=='create'){
            url = '/api/v1/workflow-center/form/save';
            responseA = await axiosInstance.post(`${process.env.REACT_APP_API_URL}${url}`, obj);
          }else{
            url = '/api/v1/workflow-center/form/update';
            responseA = await axiosInstance.put(`${process.env.REACT_APP_API_URL}${url}`, obj);
          }
          if (responseA.status == 200) {
            if (commitOn) {
              let saveObj = {
                "branch": values.branch,
                "commit_message": values.message,
                "actions": [

                  {
                    "action": "create",
                    "file_path": `${values.subdirectory}/${processKey.formKey}.json`,
                    "content": JSON.stringify(obj)
                  }

                ]
              }
              saveCommit(saveObj);

            } else{
              message.success('Schema updated Successfully');
              setLoading(false);
              setVisible(false);
            }
          } else {
            message.error('Something went wrong');
          }
          console.log('des2', obj);

        })
        .catch((info) => {
          console.log('Validate Failed:', info)
          setLoading(false);
          //setVisible(false)
        })
    } catch (error) { 

console.log ('update error',error)

    }
  }
  return (
    <>
      <Modal
        title={action=='update'?"Update Schema":"Create Schema"}
        visible={visible}
        onCancel={(e) => setVisible(false)}
        onOk={(e) => save()}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleOk}
          >
            Save
          </Button>,
        ]}
      >
        <Form
          form={form}
          onFinish={save}
          initialValues={processKey}
          layout="vertical"
          autoComplete="off"
        >
          <Form.Item
            name="formKey"
            label="Form Key"
            rules={[{ required: true, message: 'Please input form key.' }]}
          >
            <Input
              placeholder=""
              onChange={(e) =>{
                if (action=='update')
                    setProcessKey({ id: processKey?.id, formKey: e.target.value })
                else
                    setProcessKey({formKey: e.target.value })
                    
              }}
              value={processKey?.id}
            />
          </Form.Item>

        {action=='update' && <Form.Item
            name="id"
            label="Form Id"
            rules={[{ required: true, message: 'Please input form id.' }]}
          >
            <Input
              onChange={(e) =>{
               
                if (action=='update')
                  setProcessKey({id: e.target.value,formKey: processKey?.formKey})
                else
                 setProcessKey({formKey: processKey?.formKey})
                  
               } }
              value={processKey.id}
            />
          </Form.Item>
}


          {gitToken &&
            <Form.Item name="isCommit" valuePropName="checked"  >

              <Checkbox  onChange={onChange}>Commit Changes</Checkbox>
            </Form.Item>
          }
          {commitOn && gitToken && (
            <>
              <Form.Item
                name="branch"
                label="Branch"
                rules={[
                  { required: commitOn, message: 'Please select your branch.' },
                ]}
              >
                <Select
                  onChange={(value) => {

                    setSubDirectories([]);
                    getDirectories(null, setMainDirectories, value);
                  }}
                  placeholder="Please select a category"
                >
                  <Option key={0} value={''} selected>Select Branch</Option>
                  {gitBranches && gitBranches.map((item: any, index) => (
                    <Option key={index + 1} value={item.name}>{item.name}</Option>

                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="maindirectory"
                label="Main Directory"
                rules={[
                  {
                    required: commitOn,
                    message: 'Please select main directory.',
                  },
                ]}
              >
                <Select
                  onChange={(value) => {
                    setSubDirectories([]);
                    getDirectories(value, setSubDirectories, form.getFieldValue('branch'));
                  }}
                  placeholder="Please select a category"
                >
                  <Option key={0} value={''} selected>Select Main Directory</Option>
                  {mainDirectories && mainDirectories.filter((directory: any) => directory.type == 'tree').map((item: any, index) => (
                    <Option key={index + 1} value={item.path}>{item.name}</Option>

                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="subdirectory"
                label="Sub Directory"
                rules={[
                  {
                    required: commitOn,
                    message: 'Please select sub directory.',
                  },
                ]}
              >
                <Select

                  placeholder="Please select sub directory"
                >
                  <Option key={0} value={''} selected>Select Sub Directory</Option>
                  {subDirectories && subDirectories.filter((directory: any) => directory.type == 'tree').map((item: any, index) => (

                    <Option key={index + 1} value={item.path}>{item.name}</Option>

                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Commit Message"
                name="message"
                rules={[
                  {
                    max: 72,
                    required: commitOn,
                    message: 'Please write a commit message.',
                  },
                ]}
              >
                <TextArea rows={4} placeholder="" maxLength={72} />
              </Form.Item>
            </>
          )}
        </Form>
      </Modal>
      <Space>
      <Button
        onClick={() => {

          setGitToken(
            gitToken ? gitToken : (localStorage?.getItem('token') as any)
          )
          setGitApiUrl(
            gitApiUrl ? gitApiUrl : (localStorage?.getItem('apiurl') as any)
          )
          setAction('update');
          getGitBranches();
          setVisible(true);

        }}
        type="primary"
      >
        Update Schema
      </Button>
      <Button 
         onClick={() => {

          setGitToken(
            gitToken ? gitToken : (localStorage?.getItem('token') as any)
          )
          setGitApiUrl(
            gitApiUrl ? gitApiUrl : (localStorage?.getItem('apiurl') as any)
          )
          setAction('create');
          getGitBranches();
          setVisible(true);

        }}
        type="primary">Create new schema</Button>
      </Space>
    </>
  )
}

const PostNewSchemaPopOver = () => {
  let [ProcessKey, setProcessKey] = useState<{ formKey: any }>()
  const designer = useDesigner()

  const save = async () => {
    try {
      let desVar: IFormilySchema = { schema: {}, form: {} }
      console.log('des', transformToSchema(designer.getCurrentTree()))
      desVar = transformToSchema(designer.getCurrentTree())
      let obj = { ...ProcessKey, schema: desVar.schema }

      let url = '/api/v1/workflow-center/form/save'
      let responseA = await axiosInstance.post(`${process.env.REACT_APP_API_URL}${url}`, obj)
      if (responseA.status == 200) {
        message.success('New Schema Created Successfully')
      } else if (responseA.status == 400) {
        message.error(
          'Schema has been founded for the given FormKey. Please use a new FormKey'
        )
      }
      console.log('des2', obj)
    } catch (error) { }
  }
  return (
    <Popover
      content={
        <Form onFinish={save} layout="vertical" autoComplete="off">
          <Form.Item
            name="formKey"
            label="Form Key"
            rules={[{ required: true, message: 'Please input form key.' }]}
          >
            <Input
              placeholder=""
              onChange={(e) => setProcessKey({ formKey: e.target.value })}
            />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      }
      // open={false}
      title="Create schema"
      trigger="click"
    >
      <Button type="primary">Create new schema</Button>
    </Popover>
  )
}

const GetSchemaPopOver = ({ updateFormData }: ParentProps) => {
  let [ProcessKey, setProcessKey] = useState<{ formKey: any }>()
  const designer = useDesigner()
  const [messageApi, contextHolder] = message.useMessage()

  const updateParentFormData = (id: number, key: string) => {
    updateFormData({ id, formKey: key })
  }

  const save = async () => {
    try {
      let desVar: any = { schema: {}, form: {} }
      console.log('des', transformToSchema(designer.getCurrentTree()))
      desVar = transformToSchema(designer.getCurrentTree())

      let url = '/api/v1/workflow-center/form/get'
      let responseA = await axiosInstance.get(`${process.env.REACT_APP_API_URL}${url}`, {
        params: ProcessKey,
      })
      if (responseA.status == 200) {
        console.log('GET schema response data:', responseA.data)
        let responseData = responseA.data
        if (responseData && responseData.data && !responseData.schema) {
          responseData = responseData.data
        }

        let schemaField = responseData.schema
        if (typeof schemaField === 'string') {
          try {
            schemaField = JSON.parse(schemaField)
          } catch (e) {
            console.error('Failed to parse schema string:', e)
          }
        }

        let parsedSchema: any = {}
        let parsedForm: any = {}

        if (schemaField && typeof schemaField === 'object') {
          if ('schema' in schemaField) {
            parsedSchema = schemaField.schema || {}
            parsedForm = schemaField.form || {}
          } else {
            parsedSchema = schemaField
            parsedForm = responseData.form || {}
          }
        }

        desVar.schema = parsedSchema
        desVar.form = parsedForm

        console.log('Final desVar for transformToTreeNode:', desVar)

        if (!desVar.schema || typeof desVar.schema !== 'object') {
          desVar.schema = {
            type: 'object',
            properties: {},
          }
        }

        try {
          const treeNode = transformToTreeNode(desVar)
          console.log('Successfully generated treeNode:', treeNode)
          designer.setCurrentTree(treeNode)
          messageApi.success('Schema fetched successfully')
        } catch (treeError) {
          console.error('Error transforming schema to treeNode:', treeError)
          messageApi.error('Error parsing schema tree structure')
        }
       
        updateParentFormData(responseData.id, responseData.formKey)
      }
      console.log('des1', transformToSchema(designer.getCurrentTree()))

      console.log('responseA', responseA)
    } catch (error) {
      console.log('er', error)
      messageApi.error('Failed to fetch schema')
    }
  }
  return (
    <>
      {contextHolder}
      <Popover
        content={
          <Form onFinish={save} layout="vertical" autoComplete="off">
            <Form.Item
              name="formKey"
              label="Form Key"
              rules={[{ required: true, message: 'Please input form key.' }]}
            >
              <Input
                placeholder=""
                onChange={(e) => setProcessKey({ formKey: e.target.value })}
              />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        }
        // open={false}
        title="Create schema"
        trigger="click"
      >
        <Button type="primary">Get schema</Button>
      </Popover>
    </>
  )
}

export const ActionsWidget = observer(() => {
  let navigate = useNavigate()
  const designer = useDesigner()
  const [formData, setFormData] = useState<FormData>()

  useEffect(() => {
    console.log('playground')
  }, [])
  useEffect(() => {
    loadInitialSchema(designer)
  }, [designer])

  useEffect(() => {
    if (!supportLocales.includes(GlobalRegistry.getDesignerLanguage())) {
      GlobalRegistry.setDesignerLanguage('en-us')
    }
  }, [])

  const updateFormData = (data: FormData) => {
    setFormData(data)
  }

  return (
    <Space style={{ marginRight: 10 }}>
      <GetSchemaPopOver updateFormData={updateFormData} />
      <PutUpdateSchemaPopOver  maindirectory={''} subdirectory={''} message={''} branch={''} isCommit={true} id={formData?.id} formKey={formData?.formKey} />
 
      <Button
        type="primary"
        onClick={() => {
          saveSchema(designer)
        }}
      >
        <TextWidget>Save</TextWidget>
      </Button>
      <GetMyAccountMenu />
    </Space>
  )
})
